import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "tiles-container" }
const _hoisted_2 = { class: "tiles-text" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("div", { class: "spacing-25" }, null, -1)
const _hoisted_4 = { class: "text-h6 mb-1" }
const _hoisted_5 = /*#__PURE__*/_createElementVNode("div", { class: "text-caption" }, " Over the last 28 days ", -1)
const _hoisted_6 = { class: "text-h4" }
const _hoisted_7 = /*#__PURE__*/_createElementVNode("div", { class: "spacing-25" }, null, -1)
const _hoisted_8 = { class: "text-h6 mb-1" }
const _hoisted_9 = { style: {"width":"300px","height":"300px"} }
const _hoisted_10 = /*#__PURE__*/_createElementVNode("div", { class: "spacing-25" }, null, -1)
const _hoisted_11 = { class: "text-h6 mb-1" }
const _hoisted_12 = { style: {"width":"300px","height":"300px"} }
const _hoisted_13 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_14 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_15 = { key: 0 }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_v_card_item = _resolveComponent("v-card-item")!
  const _component_v_card = _resolveComponent("v-card")!
  const _component_Pie = _resolveComponent("Pie")!
  const _component_v_col = _resolveComponent("v-col")!
  const _component_v_row = _resolveComponent("v-row")!
  const _component_v_data_table = _resolveComponent("v-data-table")!
  const _component_v_container = _resolveComponent("v-container")!
  const _component_v_main = _resolveComponent("v-main")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("div", _hoisted_1, [
      _createVNode(_component_v_card, {
        elevation: "4",
        color: "white",
        variant: "elevated",
        class: "mx-auto my-3",
        style: {"width":"300px","height":"175px"}
      }, {
        default: _withCtx(() => [
          _createVNode(_component_v_card_item, null, {
            default: _withCtx(() => [
              _createElementVNode("div", _hoisted_2, [
                _hoisted_3,
                _createElementVNode("div", _hoisted_4, "Number of " + _toDisplayString(_ctx.breakdownDisplayNamePlural), 1),
                _hoisted_5,
                _createElementVNode("p", _hoisted_6, _toDisplayString(_ctx.numberOfBreakdowns), 1)
              ])
            ]),
            _: 1
          })
        ]),
        _: 1
      })
    ]),
    _createVNode(_component_v_main, {
      class: "p-1",
      style: {"min-height":"300px"}
    }, {
      default: _withCtx(() => [
        _createVNode(_component_v_container, {
          style: {"min-height":"300px"},
          class: "px-4 elevation-2"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_v_row, null, {
              default: _withCtx(() => [
                _createVNode(_component_v_col, { cols: "6" }, {
                  default: _withCtx(() => [
                    _createVNode(_component_v_card, null, {
                      default: _withCtx(() => [
                        _createVNode(_component_v_card_item, { class: "d-flex justify-center align-center" }, {
                          default: _withCtx(() => [
                            _hoisted_7,
                            _createElementVNode("div", _hoisted_8, "Top 5 " + _toDisplayString(_ctx.breakdownDisplayNamePlural) + " by accepted prompts", 1),
                            _createElementVNode("div", _hoisted_9, [
                              _createVNode(_component_Pie, {
                                data: _ctx.breakdownsChartDataTop5AcceptedPrompts,
                                options: _ctx.chartOptions
                              }, null, 8, ["data", "options"])
                            ])
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }),
                _createVNode(_component_v_col, { cols: "6" }, {
                  default: _withCtx(() => [
                    _createVNode(_component_v_card, null, {
                      default: _withCtx(() => [
                        _createVNode(_component_v_card_item, { class: "d-flex justify-center align-center" }, {
                          default: _withCtx(() => [
                            _hoisted_10,
                            _createElementVNode("div", _hoisted_11, "Top 5 " + _toDisplayString(_ctx.breakdownDisplayNamePlural) + " by acceptance rate", 1),
                            _createElementVNode("div", _hoisted_12, [
                              _createVNode(_component_Pie, {
                                data: _ctx.breakdownsChartDataTop5AcceptanceRate,
                                options: _ctx.chartOptions
                              }, null, 8, ["data", "options"])
                            ])
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }),
            _hoisted_13,
            _createElementVNode("h2", null, _toDisplayString(_ctx.breakdownDisplayNamePlural) + " Breakdown ", 1),
            _hoisted_14,
            _createVNode(_component_v_data_table, {
              headers: _ctx.headers,
              items: _ctx.breakdownList,
              class: "elevation-2",
              style: {"padding-left":"100px","padding-right":"100px"}
            }, {
              item: _withCtx(({item}) => [
                _createElementVNode("tr", null, [
                  _createElementVNode("td", null, _toDisplayString(item.name), 1),
                  _createElementVNode("td", null, _toDisplayString(item.acceptedPrompts), 1),
                  _createElementVNode("td", null, _toDisplayString(item.acceptedLinesOfCode), 1),
                  (item.acceptanceRate !== undefined)
                    ? (_openBlock(), _createElementBlock("td", _hoisted_15, _toDisplayString(item.acceptanceRate.toFixed(2)) + "%", 1))
                    : _createCommentVNode("", true)
                ])
              ]),
              _: 1
            }, 8, ["headers", "items"])
          ]),
          _: 1
        })
      ]),
      _: 1
    })
  ]))
}